export enum InteractionObjectType {
  PROJECT = "Project",
  ORGANISATION = "Organisation",
  ISSUANCE = "Issuance",
  ISSUANCE_TRANSACTION = "Issuance Transaction",
  DEAL = "Deal",
  LANDHOLDING = "Landholding",
}

export enum ObjectInteractionObjectType {
  PROJECT = "Project",
  ORGANISATION = "Organisation",
}

export enum InteractionType {
  TAG = "Tag",
  NOTE = "Note",
}
